import React, { Component } from 'react'
import Header from '../components/Header'
import Card1 from '../components/cards/Card1'
import { connect } from 'react-redux';
import { changeStateValue } from '../redux/MainReducer';
import { getSubCategories, getCategories } from '../actions/MainAction';
export class SubCategoryPage extends Component {
    getDroopValue(arr, label, value){
        console.log(arr)
        let newArr = [];
        for(const item of arr){
            newArr.push({
                label: item?.translate[label],
                value: item[value],
            })
        }
        return newArr
    }
  openModal=(data, lang, lang_id=1)=>{
    // console.log(lang, lang_id)
    this.props.changeStateValue({
      name:"mainModal",
      value:{
        position:true,
        id: data?.id?data?.id:"",
        category_id: data?.category_id?data?.category_id:"",
        languages:
          {
            id:lang?.id?lang?.id:'',
            title:lang?.title?lang?.title:'',
            lang_id:lang_id
          }
        ,
        requiredsLang: ["title"],
        requireds:[],
        afterCallFunction:this.props.getSubCategories,
        afterParams:[],
        categoryOption: this.getDroopValue(this.props.categoryData, "title", "id"),
        url:'admin-sub-category',
        nonOverflow:true
      }
    })
  }

  componentDidMount(){
    this.props.getSubCategories();
    this.props.getCategories();
  }
  render() {
    const {subCategoryData} = this.props;
    console.log(subCategoryData)
    return (
      <div className='p-[40px] w-full'>
        <Header btn={true} onClickBtn={this.openModal.bind(this, "", "", 1)} title="Alt kateqoriyalar" />
        <div className='grid-full-250 grid grid-cols-2 mt-[20px]'>
            {
            subCategoryData?.map((data, i)=>{
                return(
                <Card1 
                    key={i}
                    onChangeLang={(id)=>this.openModal(data, data.translates.find(x=>x.lang_id==id), id)} 
                    title1={data?.translate?.title}
                    title2={data?.category?.translate?.title}
                    deleteUrl={`admin-sub-category/${data?.id}`}
                    afterCallFunction={()=> this.props.getSubCategories()}
                />
                )
            })
            }
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state)=>({
  subCategoryData: state.Data.subCategoryData,
  categoryData: state.Data.categoryData,
});
const mapDispatchToProps = {changeStateValue, getSubCategories, getCategories}
export default connect(mapStateToProps, mapDispatchToProps)(SubCategoryPage)
  